import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ALLOWED_BUYER_EMAIL = "hamaad_karim@hotmail.com";

const BuyerProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  // Only allow the specific buyer email
  if (user.email?.toLowerCase() !== ALLOWED_BUYER_EMAIL.toLowerCase()) {
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
};

export default BuyerProtectedRoute;
